import React from "react"
import PropTypes from "prop-types"
import { Flex } from "antd"
import { CloseOutlined } from "@ant-design/icons"
import { Text } from "ui/Typography"
import { useTranslation } from "react-i18next"
import EquipmentTable from "../EquipmentTable"
import EquipmentFilters from "../EquipmentFilters"
import styles from "./index.module.css"

const AvailableEquipmentSection = ({ equipment, selectedCategories, onAssign, onCategoryChange, onClose, canEdit }) => {
  const { t } = useTranslation()

  const handleAssign = (item) => {
    onAssign(item)
  }

  return (
    <div className={styles.addEquipmentSection}>
      <Flex vertical gap={24}>
        <Flex align="center" justify="space-between">
          <Text fw={600} size="xl" className="m-none">
            {t("booking.equipment.add_equipment")}
          </Text>
          <button className={styles.closeButton} onClick={onClose}>
            <CloseOutlined />
          </button>
        </Flex>

        <EquipmentFilters selectedCategories={selectedCategories} onCategoryChange={onCategoryChange} />

        <Flex vertical gap={12}>
          <Flex align="center" gap={8}>
            <Text className={styles.availableEquipmentTitle}>{t("booking.equipment.available_equipment")}</Text>
            <Text className={styles.countText}>({equipment.length})</Text>
          </Flex>

          <EquipmentTable
            equipment={equipment}
            onAction={handleAssign}
            actionType="assign"
            emptyMessage={t("booking.equipment.no_available_equipment")}
            canEdit={canEdit}
          />
        </Flex>
      </Flex>
    </div>
  )
}

AvailableEquipmentSection.propTypes = {
  equipment: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      name: PropTypes.string.isRequired,
      assetNumber: PropTypes.string.isRequired,
      category: PropTypes.string.isRequired
    })
  ).isRequired,
  selectedCategories: PropTypes.arrayOf(PropTypes.string).isRequired,
  onAssign: PropTypes.func.isRequired,
  onCategoryChange: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  canEdit: PropTypes.bool
}

export default AvailableEquipmentSection
